export default {
      id: "menu-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite.svg#menu",
      toString: function () {
        return this.url;
      }
    }